import { FETCH_CERTIFICATE_JOB_READY } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_CERTIFICATE_JOB_READY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
